import { useState } from "react";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import { http } from "@/lib/api";
import { Reveal } from "./Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQ = [
  ["Comment acheter un produit ?", "Cliquez sur « Voir le prix sur Amazon » ou « Découvrir » : vous arrivez sur le site du marchand. C'est lui qui vend, livre et gère le service après-vente."],
  ["Pourquoi les prix ne sont-ils pas affichés ici ?", "Les prix changent souvent chez nos partenaires. Vous voyez le prix exact et à jour directement sur leur site, avant de payer."],
  ["Comment Kairos est-il rémunéré ?", "Nous percevons une commission quand vous achetez via nos liens partenaires. Cela ne change rien au prix que vous payez."],
  ["Que sont les « Top ventes » ?", "Ce sont les classements officiels des meilleures ventes Amazon, mis à jour en continu par Amazon. Nous ne les modifions pas."],
  ["Les logiciels sont-ils gratuits ?", "La plupart proposent une offre gratuite pour commencer. Les offres payantes et leurs conditions sont gérées directement par l'éditeur."],
];

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="mx-auto grid max-w-[1440px] gap-12 px-5 py-24 sm:px-10 sm:py-32 lg:grid-cols-12">
    <Reveal className="lg:col-span-4">
      <p className="font-mono-label text-xs text-[var(--muted)]">(05) — Aide</p>
      <h2 className="font-display mt-5 text-4xl sm:text-5xl font-light tracking-tight">Questions <em className="italic text-[var(--terra)]">fréquentes</em></h2>
    </Reveal>
    <Reveal delay={0.1} className="lg:col-span-7 lg:col-start-6">
      <Accordion type="single" collapsible>
        {FAQ.map(([q, a], i) => (
          <AccordionItem key={i} value={`q${i}`} className="border-[var(--line)]">
            <AccordionTrigger data-testid={`faq-trigger-${i}`} className="font-display py-6 text-left text-lg sm:text-xl font-normal hover:no-underline">{q}</AccordionTrigger>
            <AccordionContent className="pb-6 text-base leading-relaxed text-[var(--muted)]">{a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </Reveal>
  </section>
);

export const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await http.post("/newsletter", { email });
      toast.success("Bienvenue chez Kairos — votre première sélection arrive bientôt.");
      setEmail("");
    } catch {
      toast.error("Adresse email invalide.");
    } finally {
      setLoading(false);
    }
  };
  return (
    <section data-testid="newsletter-section" className="px-5 sm:px-10">
      <div className="grain relative mx-auto max-w-[1440px] overflow-hidden rounded-[28px] bg-[var(--terra)] px-6 py-16 text-[var(--bone)] sm:px-14 sm:py-24">
        <div className="relative z-10 grid gap-10 lg:grid-cols-2 lg:items-end">
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.02] tracking-tight">
            Une lettre par mois. <em className="italic">Rien de plus.</em>
          </h2>
          <form onSubmit={submit} className="flex flex-col gap-3 sm:flex-row">
            <input data-testid="newsletter-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="votre@email.fr"
              className="flex-1 rounded-full border border-white/50 bg-white/10 px-6 py-4 text-base text-white placeholder:text-white/80 outline-none focus:border-white" />
            <button data-testid="newsletter-submit-button" disabled={loading}
              className="group inline-flex items-center justify-center gap-2 rounded-full bg-[var(--ink)] px-7 py-4 text-sm transition-colors hover:bg-black disabled:opacity-60">
              S'inscrire <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};
